import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiMessage } from 'src/app/services/ai-audience-generation/ai-audience-generation.service';
import { ChatMessageComponent } from '../chat-message/chat-message.component';
import { TypingIndicatorComponent } from '../typing-indicator/typing-indicator.component';
import { EmptyConversationStateComponent } from '../empty-conversation-state/empty-conversation-state.component';
import { AudienceSizeMessageComponent } from '../audience-size-message/audience-size-message.component';

@Component({
  selector: 'app-conversation-messages',
  templateUrl: './conversation-messages.component.html',
  styleUrls: ['./conversation-messages.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ChatMessageComponent,
    TypingIndicatorComponent,
    EmptyConversationStateComponent,
    AudienceSizeMessageComponent
  ]
})
export class ConversationMessagesComponent implements AfterViewChecked, OnChanges {
  @Input() messages: AiMessage[] = [];
  @Input() isLoading = false;
  @Input() loadingText = 'Analyzing your request...';
  @Output() promptSelected = new EventEmitter<string>();
  @Output() retryMessage = new EventEmitter<string>();
  @ViewChild('messagesContainer') private messagesContainer?: ElementRef;

  private shouldScrollToBottom = false;

  get isEmpty(): boolean {
    return this.messages.length === 0 && !this.isLoading;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['messages'] || changes['isLoading']) {
      this.shouldScrollToBottom = true;
    }
  }

  ngAfterViewChecked(): void {
    if (this.shouldScrollToBottom) {
      this.scrollToBottom();
      this.shouldScrollToBottom = false;
    }
  }

  private scrollToBottom(): void {
    if (this.messagesContainer) {
      try {
        this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
      } catch (err) {
        console.error('Error scrolling to bottom:', err);
      }
    }
  }

  isSmallAudienceSize(size?: number): boolean {
    return size !== undefined && size < 50000;
  }

  onPromptSelected(prompt: string): void {
    this.promptSelected.emit(prompt);
  }

  onRetryMessage(prompt: string): void {
    this.retryMessage.emit(prompt);
  }
}
